export default class ClockStates {
    public static readonly ClockIn: ClockStatesType = "ClockIn";                 // user is clocked in
    public static readonly ClockOut: ClockStatesType = "ClockOut";               // user is clocked out
    public static readonly StartBreak: ClockStatesType = "StartBreak";           // user has started break
    public static readonly EndBreak: ClockStatesType = "EndBreak";               // user has ended break
    public static readonly Unknown: ClockStatesType = "Unknown";                // user clock status is unknown
}

export type ClockStatesType = "ClockIn" | "ClockOut" | "Unknown" | "StartBreak" | "EndBreak";